import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
const defaultOptions = {} as const;

export type NetworksRemoveAssignmentMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.RemoveAssignmentInput;
}>;

export type NetworksRemoveAssignmentMutationResult = { __typename?: 'Mutation' } & {
  networksRemoveAssignment?: GraphQLTypes.Maybe<
    { __typename?: 'RemoveAssignmentPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const NetworksRemoveAssignmentDocument = /*#__PURE__*/ gql`
  mutation networksRemoveAssignment($input: RemoveAssignmentInput!) {
    networksRemoveAssignment(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useNetworksRemoveAssignmentMutation__
 *
 * To run a mutation, you first call `useNetworksRemoveAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNetworksRemoveAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [networksRemoveAssignmentMutation, { data, loading, error }] = useNetworksRemoveAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNetworksRemoveAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<NetworksRemoveAssignmentMutationResult, NetworksRemoveAssignmentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<NetworksRemoveAssignmentMutationResult, NetworksRemoveAssignmentMutationVariables>(
    NetworksRemoveAssignmentDocument,
    options
  );
}
export type NetworksRemoveAssignmentMutationHookResult = ReturnType<typeof useNetworksRemoveAssignmentMutation>;
